<template>
  <div class="group">
    <input type="checkbox" id="marketing_consent" name="marketing_consent" v-model="$parent.fields.marketing_consent" @change="$parent.validation.marketing_consent = null">
    <label for="marketing_consent">Please add me to the ResMed community so I can receive ResMed product and marketing information. I understand that if I change my mind, I can opt-out at any time. <a href="/privacy/" target="_blank">Privacy Policy</a>.</label>
    <div class="error-message only-text" v-for="message in $parent.validation.marketing_consent">{{ message }}</div>
  </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'marketingConsent',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ]
    }
</script>
